/**
 * @generated SignedSource<<61ae8147b0ba730ffd19df556562a17b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uuid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "uuid"
      }
    ],
    "concreteType": "Portfolio",
    "kind": "LinkedField",
    "name": "retirePortfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioRetireMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioRetireMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d9af10a05921d03e165749ebec75d0e5",
    "id": null,
    "metadata": {},
    "name": "PortfolioRetireMutation",
    "operationKind": "mutation",
    "text": "mutation PortfolioRetireMutation(\n  $uuid: ID!\n) {\n  retirePortfolio(uuid: $uuid) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "01a3c93909a7f5b6b262df0cb00798a4";

module.exports = node;
